import { CompanionPanel } from "@components/CompanionPanel";
import { PanelError, SkeletonStack } from "@scribenote/brian-design-system";
import { ViewsBrowser } from "@views/ViewsBrowser";
import { useActiveSubject } from "@workspace/useActiveSubject";

export const ViewsPanel = () => {
  const subjectId = useActiveSubject()?.id ?? null;

  return (
    <CompanionPanel
      skeleton={<ViewsSkeleton />}
      fallback={(retry) => <PanelError label="views" onRetry={retry} />}
      resetKeys={[subjectId]}
    >
      <ViewsBrowser
        subject={subjectId}
        emptyLabel={
          subjectId
            ? "I haven’t surfaced anything about this one."
            : "I haven’t surfaced any views yet."
        }
      />
    </CompanionPanel>
  );
};

const ViewsSkeleton = () => (
  <SkeletonStack count={4} className="gap-3" itemClassName="h-20" />
);
